module.exports = "<div fxLayout=\"column\" fxLayoutAlign=\"space-around\">\r\n  <navbar></navbar>\r\n  <router-outlet></router-outlet>\r\n  <app-footer></app-footer>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 372
// module chunks = 1